<template>
  <!-- 订单录入 -->
  <div class="editPage">
    <OrderProgress
      ref="progress"
      v-model="progressPamars"
      :progressConfig="progressConfig"
      :checkNextStep="true"
      @preStep="preStep"
      @nextStep="nextStep"
    />
    <qx-card title="订单录入" v-show="progressPamars.step === 1">
      <section>
        <BaseForm ref="baseForm" @getCombineinfo="getCombineinfo" @getDependTime="getDependTime" />
        <LineForm ref="lineForm" @calcDistance="calcDistance" />
        <CustomerForm ref="customerForm" @calCostPrice="calCostPrice" />
        <CarriageForm ref="carriageForm" @calCostPrice="calCostPrice" />
        <IncomeForm
          ref="incomeForm"
          @calCostPrice="calCostPrice"
          @calPreAndFinalFee="calPreAndFinalFee"
          @changePrePayCash="changePrePayCash"
          @changeAfterPayCash="changeAfterPayCash"
          @changePrePayEquivalenceCardAmount="changePrePayEquivalenceCardAmount"
          @changeAfterPayEquivalenceCardAmount="
            changeAfterPayEquivalenceCardAmount
          "
        />
        <SettlementForm ref="settlementForm" />
      </section>
    </qx-card>

    <qx-card title="调度信息" v-show="progressPamars.step === 2">
      <ModeForm
        ref="modeForm"
        @queryMemberBenefits="queryMemberBenefits"
        @setBelongForm="setBelongForm"
        @appointWayChange="appointWayChange"
      />
      <DispatchSettlementForm ref="dispatchSettlementForm" />
      <BelongForm
        ref="belongForm"
        @getBaseUser="getBaseUser"
        @setVehicleStaffForm="setVehicleStaffForm"
      />
    </qx-card>

    <qx-card title="备注" v-show="progressPamars.step === 3">
      <OtherForm ref="otherForm" @isNeedBillChange="isNeedBillChange" @goFirstStep="goFirstStep" />
    </qx-card>
  </div>
</template>

<script>
import BaseForm from './input/base';
import LineForm from './input/line';
import CustomerForm from './input/customer';
import CarriageForm from './input/carriage';
import IncomeForm from './input/income';
import SettlementForm from './input/settlement';

import ModeForm from './dispatch/mode/mode';
import DispatchSettlementForm from './dispatch/settlement/settlement';
import BelongForm from './dispatch/belong/belong';

import OtherForm from './other/other';

import pageDataMixin from '@qx/mixin/pageData';
import OrderProgress from 'components/progress/progress';
import {
  getCarTypeList,
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {
  getDefaultBillInfo,
  saveOrder,
  queryOrderDetail,
  getOperInteCfgResultInfo,
} from 'api/operate';
import {
  fnCalCostPrice,
  fnCalPreAndFinalFee,
  fnChangePrePayCash,
  fnChangeAfterPayCash,
  fnChangePrePayEquivalenceCardAmount,
  fnChangeAfterPayEquivalenceCardAmount,
} from './input/calc';

const IMG_INPUT = require('../../../../../assets/images/operate/order/input.png');
const IMG_INPUT_ACTIVE = require('../../../../../assets/images/operate/order/inputActive.png');
const IMG_DISPATCH = require('../../../../../assets/images/operate/order/dispatch.png');
const IMG_DISPATCH_ACTIVE = require('../../../../../assets/images/operate/order/dispatchActive.png');
const IMG_OTHER = require('../../../../../assets/images/operate/order/other.png');
const IMG_OTHER_ACTIVE = require('../../../../../assets/images/operate/order/otherActive.png');
const safeEnum = (enumsList, index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    LineForm,
    CustomerForm,
    CarriageForm,
    IncomeForm,
    SettlementForm,

    ModeForm,
    DispatchSettlementForm,
    BelongForm,

    OtherForm,
    OrderProgress,
  },
  data () {
    return {
      progressPamars: {
        step: 1,
      },
      progressConfig: [
        {
          label: '订单录入',
          normalImgUrl: IMG_INPUT,
          activeImgUrl: IMG_INPUT_ACTIVE,
        },
        {
          label: '调度信息',
          normalImgUrl: IMG_DISPATCH,
          activeImgUrl: IMG_DISPATCH_ACTIVE,
        },
        {
          label: '备注',
          normalImgUrl: IMG_OTHER,
          activeImgUrl: IMG_OTHER_ACTIVE,
        },
      ],
      pageUrl: this.$route.query.id ? '/manage/operate/order/deal/edit' : '/manage/operate/orderInput/logged',
      formComponents: [
        'baseForm',
        'lineForm',
        'customerForm',
        'carriageForm',
        'incomeForm',
        'settlementForm',

        'modeForm',
        'dispatchSettlementForm',
        'belongForm',

        'otherForm',
      ],
      editParams: {
      },
    };
  },
  computed: {
    detailParams () {
      return {
        orderId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: queryOrderDetail,
    editApi: saveOrder,
    // 返回第一步
    goFirstStep () {
      this.$refs.otherForm.progressStep = 1;
      this.progressPamars.step = 1;
    },
    // 返回上一步
    preStep (step) {
      this.$refs.otherForm.progressStep = step;
    },
    // 判断是否进入下一步，以及提交
    async nextStep (step) {
      let isGoNextStep = true;
      switch (step) {
        case 1:
          isGoNextStep = await this.checkComponetsSub(
            [
              'baseForm',
              'lineForm',
              'customerForm',
              'carriageForm',
              'incomeForm',
              'settlementForm',
            ]);
          if (isGoNextStep) {
            this.$refs.otherForm.progressStep = step;
            this.$refs.progress.toNextStep();
          }
          break;
        case 2:
          isGoNextStep = await this.checkComponetsSub([
            'modeForm',
            'dispatchSettlementForm',
            'belongForm',
          ]);
          if (isGoNextStep) {
            this.$refs.otherForm.progressStep = step;
            this.$refs.progress.toNextStep();
          }
          break;
        case 3:
          // 最后全部校验通过，提交
          this.$refs.otherForm.progressStep = step;
          this.sub();
          break;
        default:
          break;
      }
    },
    // 检测每个步骤
    async checkComponetsSub (componentListName) {
      let isGoNextStep = true;
      for (let i = 0; i < componentListName.length; i++) {
        const formData = await this.$refs[componentListName[i]].sub();
        // 如果有不通过验证的，formData 会返回 null，以此来判断是否可以前往下一步
        if (!formData) {
          isGoNextStep = false;
          break;
        }
      }
      return isGoNextStep;
    },
    // 提交成功后，弹出窗口提示
    async handleSubSucc (res) {
      if (res && res.code && res.code === 202) {
        this.$alert(res.msg, '温馨提示', {
          confirmButtonText: '我知道了',
        });
        this.close();
      } else {
        await this.$confirm(`操作成功${res.data ? `，订单号：${res.data}` : ''}`, '提示', {
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '继续录入',
          cancelButtonText: '返回订单列表',
          showCancelButton: true,
          type: 'success',
        }).then(() => {
          // 如果点击继续录入，返回订单录入页面
          this.$router.go('/manage/operate/orderInput/logged');
        }).catch(() => {
          // 如果点击取消，页面返回订单列表
          this.close();
          this.jump({
            label: '订单处理',
            url: '/manage/operate/order/deal',
            full: true,
          });
        });

      }
    },
    // 是否开票操作
    isNeedBillChange (val) {
      this.$refs.modeForm.otherFormData.isNeedBill = val;
    },
    // 调度方式操作
    appointWayChange (val) {
      this.$refs.otherForm.optionsChange(val === '3');
    },
    // 获取靠台信息，提供给【调度信息】-【调度方式】-切换【成本模式】的时候判断用
    getDependTime (dependTime) {
      this.$refs.modeForm.setDependTime(dependTime);
    },
    // 获取线路+客户信息
    getCombineinfo (combineinfo) {
      for (let formItem of this.formComponents) {
        if (this.$refs[formItem] && this.$refs[formItem].setData) {
          this.$refs[formItem].setData(combineinfo);
        }
      }
    },
    calcDistance ({ state, distance }) {
      if (state === 'start') {
        this.$refs.customerForm.calcIng = true;
        this.$refs.carriageForm.calcIng = true;
      }
      if (state === 'finish') {
        this.$refs.customerForm.calcIng = false;
        this.$refs.carriageForm.calcIng = false;
        this.$refs.customerForm.setDistant(distance);
        this.$refs.carriageForm.setDistant(distance);
      }
    },
    // 结算信息
    queryMemberBenefits (options) {
      setTimeout(() => {
        this.$refs.dispatchSettlementForm.queryMemberBenefits(options);
      }, 100);
    },
    // 获取基本信息默认自动填充
    getBaseUser (data) {
      setTimeout(() => {
        this.$refs.modeForm.setBaseUser(data);
      }, 100);
    },
    setBelongForm (data) {
      this.$refs.belongForm.setBelongForm(data);
    },
    // 【归属】和【指派员工】的内容同步
    setVehicleStaffForm (data) {
      this.$refs.modeForm.setVehicleStaffForm(data);
    },
    // 计算单价
    calCostPrice () {
      fnCalCostPrice(this);
    },
    // 计算预付和尾款，changeType=1 重新计算；
    calPreAndFinalFee (changeType) {
      fnCalPreAndFinalFee(this, changeType);
    },
    // 改变预付现金
    changePrePayCash () {
      fnChangePrePayCash(this);
    },
    // 改变尾款现金
    changeAfterPayCash () {
      fnChangeAfterPayCash(this);
    },
    // 改变预付等值卡额
    changePrePayEquivalenceCardAmount () {
      fnChangePrePayEquivalenceCardAmount(this);
    },
    // 改变尾款等值卡额
    changeAfterPayEquivalenceCardAmount () {
      fnChangeAfterPayEquivalenceCardAmount(this);
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'GOODS_TYPE,PRICE_ENUM,EQUIVALENCE_CARD_TYPE,BALANCE_TYPE,APPOINTWAY,IS_NEED_BILL,PAYMENT_WAY',
    });
    const vehicleStatusEnumsList = await getCarTypeList();
    const defaultBillData = await getDefaultBillInfo();
    const orgIdOptions = await getDepartmentAllList();
    const goodsTypeOptions = safeEnum(enumsList, 0);
    const priceEnumList = safeEnum(enumsList, 1);
    const cardTypeList = safeEnum(enumsList, 2);
    const balanceTypeList = safeEnum(enumsList, 3);
    const appointWayList = safeEnum(enumsList, 4);
    const isNeedBillList = safeEnum(enumsList, 5);
    const paymentWayEnumList = safeEnum(enumsList, 6);
    const vehicleStatusOptions = [
      { label: '请选择', value: '-1' },
      ...vehicleStatusEnumsList,
    ];
    const priceEnumOptions = [
      ...priceEnumList,
    ];
    const cardTypeOptions = [
      { label: '请选择卡类型', value: '-1' },
      ...cardTypeList,
    ];
    const balanceTypeOptions = [
      // { label: '请选择', value: '-1' },
      ...balanceTypeList,
    ];
    const paymentWayList = await getOperInteCfgResultInfo({
      busiCode: '10010201',
      filedName: '成本模式',
    });
    let appointWayOptions = [...appointWayList];
    let isNeedBillOptions = [...isNeedBillList];
    let paymentWayOptions = paymentWayList.length > 0 ? [...paymentWayList] : [...paymentWayEnumList];
    const isEnum = paymentWayList.length <= 0; // 判断成本模式的表单是根据运营端个性化配置返回还是枚举值查询接口返回

    this.$refs.customerForm && this.$refs.customerForm.getList();
    this.$refs.carriageForm && this.$refs.carriageForm.setList([goodsTypeOptions, vehicleStatusOptions]);
    this.$refs.incomeForm && this.$refs.incomeForm.setList([priceEnumOptions, cardTypeOptions]);
    this.$refs.settlementForm && this.$refs.settlementForm.setList(balanceTypeOptions);
    this.$refs.dispatchSettlementForm && this.$refs.dispatchSettlementForm.setList(balanceTypeOptions);
    if (this.$refs.modeForm) {
      this.$refs.modeForm.setList([appointWayOptions, paymentWayOptions], { defaultBillData }, isEnum);
      this.$refs.modeForm.getParentComponent(this);
    }
    this.$refs.belongForm && this.$refs.belongForm.setList(orgIdOptions);
    if (this.$refs.otherForm) {
      this.$refs.otherForm.setList(isNeedBillOptions, { defaultBillData });
      this.$refs.otherForm.getParentComponent(this);
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
</style>
